import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import SearchMemberTypeAhead from '../Search-Member-Type-Ahead/Search-Member-Type-Ahead';
import { BuscaOrganizacao } from 'ebs-orders-reports-react-lib';
import { Configurations } from '../../Utils/Configurations';

class ModalNewPeriodicalCoordinator extends Component {
    constructor(props) {
        super(props);

        this.getMembroSelecionado = this.getMembroSelecionado.bind(this);
        this.handleFuncao = this.handleFuncao.bind(this);
        this.removeMembroSelecionado = this.removeMembroSelecionado.bind(this);
        this.habilitaFinalizar = this.habilitaFinalizar.bind(this);
        this.finalizaCadastro = this.finalizaCadastro.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleOrg = this.handleOrg.bind(this);

        this.state = {
            membroSelecionado: {},
            cp: false,
            arrayFuncao: [],
        };

        this.listaFuncoes = [
            // {
            //     idFuncao: 1,
            //     nomeFuncao: "Coordenador(a) de Impressos",
            //     funcao: 'ci'
            // },
            // {
            //     idFuncao: 2,
            //     nomeFuncao: "Entregador(a) de Impressos",
            //     funcao: 'entregador'
            // },
            // {
            //     idFuncao: 3,
            //     nomeFuncao: "DIZ",
            //     funcao: 'diz'
            // },
            {
                idFuncao: 4,
                nomeFuncao: "Coordenador(a) de Periódicos",
                funcao: 'cp'
            },
        ];

        this.Configurations = new Configurations();
    }

    getMembroSelecionado(membro) {
        if (membro && !!membro.idUsuario) this.setState({ membroSelecionado: membro })
    }

    handleFuncao(e) {
        const _value = parseInt(e.target.value, 10),
            _funcao = e.target.name;
        this.setState({
            funcaoSelecionada: _value,
            nomeFuncaoSelecionada: this.listaFuncoes.find(item => item.idFuncao === _value).nomeFuncao,
            [_funcao]: !this.state[_funcao],
        }, () => {
            this.setState({
                // arrayFuncao: [this.state.ci ? 1 : 0, this.state.entregador ? 2 : 0, this.state.diz ? 3 : 0]
                arrayFuncao: [this.state.cp ? 4 : 0]
            })
        })
    }

    removeMembroSelecionado() {
        this.setState({
            membroSelecionado: {},
            // orgSelecionada: '',
            cp: false,
            arrayFuncao: [],
        }, () => this.props.novaBusca())
    }

    habilitaFinalizar() {
        const { cp, membroSelecionado } = this.state,
            { idUsuario } = membroSelecionado;

        return (!!idUsuario) * cp
    }

    finalizaCadastro() {
        let _arrayFuncao = this.state.arrayFuncao.filter(item => item > 0)

        const _bodyMensageiro = _arrayFuncao.map((item, index) => ({
            idUsuario: this.state.membroSelecionado.idUsuario,
            idFuncao: item,
            arvoreOrg: this.state.orgSelecionada
        }))

        this.props.finalizaCadastro(_bodyMensageiro)
    }

    toggle() {
        this.setState({ membroSelecionado: {}, orgSelecionada: '' })
        this.props.toggle();
    }

    handleOrg(eValue) {
        this.setState({ orgSelecionada: eValue });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) this.setState({
            membroSelecionado: {},
            orgSelecionada: '',
            cp: false,
            arrayFuncao: [],
        })
    }

    render() {
        const { isOpen, sucessoCadastro, isLoadingCadastro, cadastroDuplicado } = this.props,
            { nome, codMembro, idUsuario } = this.state.membroSelecionado,
            { orgSelecionada } = this.state;
        return (
            <Modal size="lg" className="modal-new-edition" isOpen={isOpen} toggle={this.toggle}>
                <ModalHeader toggle={this.toggle}>
                    <div className="row no-gutters">
                        <div className="col-12">
                            Novo Cadastro
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {sucessoCadastro ? (
                        <div className="row no-gutters align-items-end">
                            <div className="col-12">
                                <p className="m-0">Cadastro realizado com sucesso.</p>
                            </div>
                        </div>
                    ) : (
                            <React.Fragment>
                                {isLoadingCadastro ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center my-5">
                                            <div className="spinner-border text-success" />
                                        </div>
                                    </div>
                                ) : (
                                        <div className="row no-gutters align-items-end">
                                            <div className="col-12">
                                                <div className="row no-gutters">
                                                    <div className="col-12 pt-2 pb-1">
                                                        <p className="m-0">Selecione a organização:</p>
                                                    </div>
                                                    <div className="col-12 py-1">
                                                        <BuscaOrganizacao handleOrg={this.handleOrg} orgSelecionada={orgSelecionada} apiBasePath={this.Configurations.apiBasePath} tokenKey={this.Configurations.tokenKey} isLoadingAPI={false} />
                                                    </div>
                                                </div>
                                            </div>
                                            {!!orgSelecionada && (
                                                <div className="col-12">
                                                    <div className="row no-gutters">
                                                        <div className="col-12 pt-2 pb-1">
                                                            <p className="m-0">Selecione o membro:</p>
                                                        </div>
                                                        <div className="col-12 py-1">
                                                            <SearchMemberTypeAhead
                                                                coordPeriodicos={true}
                                                                getMembroSelecionado={this.getMembroSelecionado}
                                                                disableInput={!!idUsuario}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {!!idUsuario && (
                                                <React.Fragment>
                                                    <div className="col-12 py-2">
                                                        <h4 className="m-0">
                                                            <span className="badge badge-primary">{nome} ({codMembro})</span>
                                                            <span onClick={this.removeMembroSelecionado} style={{ fontSize: 16 }}><i className={`far fa-trash-alt text-danger ml-2 cursor-pointer`}></i></span>
                                                        </h4>
                                                    </div>
                                                    <div className="col-12 py-2">
                                                        <div className="row no-gutters">
                                                            <div className="col-12">
                                                                <p className="m-0">Selecione a função:</p>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="form-check mx-0 px-0">
                                                                    <input type="checkbox" onChange={this.handleFuncao} className="check-box mr-2" id="4" value={4} name="cp" checked={this.state.cp} />
                                                                    <label htmlFor="4">Coordenador(a) de Periódicos</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {cadastroDuplicado && (
                                                        <div className="col-12 text-center text-danger">
                                                            <strong className="m-0">Não foi possível completar o cadastro.</strong>
                                                            <p className="m-0">O membro já possui a função selecionada.</p>
                                                        </div>
                                                    )}
                                                    <div className="col-12 py-2 text-center">
                                                        <button disabled={!this.habilitaFinalizar()} onClick={this.finalizaCadastro} className="btn btn-outline-success">finalizar cadastro</button>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                            </React.Fragment>
                        )}
                </ModalBody>
                {sucessoCadastro && (
                    <ModalFooter>
                        <Button onClick={this.toggle} color="success">Ok</Button>
                    </ModalFooter>
                )}
            </Modal>
        );
    }
}

export default ModalNewPeriodicalCoordinator;